import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { SignIn } from "src/app/models/User/SignIn.model";
import { SignInResponse } from "src/app/models/User/SignInResponse.model";
import { ApiErrorResponse, ApiService, ApiSuccessResponse } from "../api/api.service";
import { SessionService } from "../session/session.service";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    constructor(
        private api: ApiService, 
        private sessionService: SessionService, 
        private route: Router) { }

    public logout(): void {
        this.sessionService.logout();
        this.route.navigate(["/sign-in"]);
    }

    public verifyIfIsLogged(): void {
        if (this.sessionService.isLogged) {
            this.route.navigate(["/home"]);
        }
    }

    public async signIn(data: SignIn): Promise<any> {
        const r = await this.api.post<SignInResponse>('/authentication/sign-in', data);
        if (r.success) {
            this.sessionService.setToken({ token: r.data.token, refreshToken: r.data.refreshToken });
            this.sessionService.setDetails({
                id: r.data.user.id,
                idCompany: r.data.idCompany,
                email: data.email,
                currency: r.data.user.currency,
                fullName: r.data.user.fullName,
                language: r.data.user.language,
                toursToExecute: r.data.toursToExecute,
                wizardFinished:  r.data.wizardFinished,
            });
            return r;
        }
        return r;
    }

    public async administrativeSignIn(token: string): Promise<boolean> {
        const r = await this.api.post<boolean>('/authentication/admin', {Token: token});
        if (r.success) {
            return true;
        }
        else
            throw (r.message);
    }
}